import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useRouteMatch} from 'react-router-dom';

export function AdminUserInfoCard() {
  const [user, setUser] = useState({});
  const {params} = useRouteMatch('/admin/users/:id');

  const {name, email, role, _id} = user;

  useEffect(() => {
    const getUser = async () => {
      const user = await axios.get(`/api/user/${params.id}`);
      setUser(user.data);
    };
    getUser();

    return () => {
      setUser({});
    };
  }, [setUser, params.id]);
  return (
    <div>
      <h1>User Information</h1>
      <h2>{`Name: ${name}`}</h2>
      <h2>{`Role: ${role}`}</h2>
      <h2>{`Email: ${email}`}</h2>
      <h2>{`ID: ${_id}`}</h2>
    </div>
  );
}
